import { render, staticRenderFns } from "./ScheduleCalendarSkeleton.vue?vue&type=template&id=3305f353&scoped=true&"
import script from "./ScheduleCalendarSkeleton.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ScheduleCalendarSkeleton.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ScheduleCalendarSkeleton.vue?vue&type=style&index=0&id=3305f353&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3305f353",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3305f353')) {
      api.createRecord('3305f353', component.options)
    } else {
      api.reload('3305f353', component.options)
    }
    module.hot.accept("./ScheduleCalendarSkeleton.vue?vue&type=template&id=3305f353&scoped=true&", function () {
      api.rerender('3305f353', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuScheduleCalendar/ScheduleCalendarSkeleton.vue"
export default component.exports